import { FieldValues } from 'react-hook-form';
import { dataProvider } from '../../firebase';
import { IDate, ISession } from '../../types';

const REQUIRED_MESSAGE = 'Campo obligatorio';

// TODO: VALIDATE FORMS
export const validateForm = async (vals: FieldValues) => {
  const values = vals as ISession;
  const errors: Partial<ISession> = {};
  if (!values.start) {
    errors.start = REQUIRED_MESSAGE;
  }
  if (!values.start) {
    errors.end = REQUIRED_MESSAGE;
  }
  if (!values.title) {
    errors.title = REQUIRED_MESSAGE;
  }
  if (!values.locationsId) {
    (errors as FieldValues).locationsId = REQUIRED_MESSAGE;
  }
  const nStart = Number(values.start?.replace(':', '.'));
  const nEnd = Number(values.end?.replace(':', '.'));
  if (values.dateId) {
    const dt = (await dataProvider.getOne('dates', { id: values.dateId })).data as IDate;
    const fStart = Number(dt.firstSessionStart.replace(':', '.'));
    const fEnd = Number(dt.lastSessionEnd.replace(':', '.'));

    if (nStart < fStart) {
      errors.start = `El horario de comienzo de la conferencia no puede ser anterior al del comienzo del dia (${fStart})`;
    }
    if (fEnd < nEnd) {
      errors.end = `El horario de fin de la conferencia no puede ser posterior al del fin del dia (${fEnd})`;
    }
    if (nStart >= nEnd) {
      errors.end = ' El horario de finalizacion debe ser mayor que el de inicio.';
    }
  } else {
    errors.dateId = REQUIRED_MESSAGE;
  }
  console.log('Validated ', { vals, errors });
  return errors;
};
